import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { Row, Container, Col } from 'reactstrap'
import Link from 'components/elements/link'
import breakPoints from 'themes/breakPoints'
import _ from 'lodash'
import { getCurrentLanguage } from 'utils/language'
import { renderText } from 'utils/text'
import DownloadMobileApp from 'components/elements/download-mobile-app'
import ChangeLanguage from 'components/layout/footer/ChangeLanguage'
import { media } from 'styled-bootstrap-grid'

const Footer = styled.footer`
  padding-top: 80px;
  padding-bottom: 32px;
  position: relative;
  border-top: 1px solid #eee;
  .noMarginLeft {
    margin-left: 0;
  }
  .noMarginRight {
    margin-right: 0;
  }
`

const CompanyInfo = styled.div`
  margin-bottom: 32px;
  .item {
    margin-bottom: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    i {
      margin-right: 16px;
      width: 32px;
      height: 32px;
      border-radius: 16px;
      background: #f5f5f5;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
    }
  }
  .name {
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .label {
    font-weight: 600;
    display: flex;
    align-items: center;
  }
`

const MenuListStyle = styled(Col)`
  label {
    font-size: 18px;
    font-weight: 600;
    color: rgb(155, 155, 155);
    margin-bottom: 8px;
    display: block;
  }
  .menuList {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    display: flex;
    flex-direction: column;
    label {
      font-size: 1.25rem;
      border-bottom: 1px solid #eee;
      padding-bottom: 8px;
    }
    .menuList {
      flex-grow: 1;
    }
  }
`

const Menu = styled(Link)`
  font-size: 1rem;
  color: #000;
  margin-bottom: 8px;
`

const MobileApp = styled.div`
  border-top: 1px solid #eee;
  padding-top: 16px;
  margin-top: 16px;
  padding-right: 16px;
  label {
    font-weight: 600;
    color: #000;
    margin-bottom: 16px;
    display: block;
  }
`

const Stores = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const Store = styled.img`
  height: 48px;
  margin-right: 8px;
  &.mongodb {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #000;
    background: #fff;
  }
  &.paymentMethod {
    border: 1px solid #eee;
    border-radius: 4px;
    overflow: hidden;
  }
`

const CopyrightWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
  margin-top: 32px;
  padding-top: 32px;
  @media(max-width: 430px){
    flex-direction: column;
    align-items: flex-start;
    .boCongThuongTradeMark {
      margin-top: 16px;
    }
  }
`

const Copyright = styled.div`
  .copyright {
    margin-bottom: 8px;
    font-weight: 600;
    line-height: 24px;
  }
  .businessLicense {
    color: #888;
    line-height: 24px;
  }
`

const MOITAndLanguages = styled.div`
  display: flex;
  align-items: center;

  margin-top: 16px;

  ${media.lg`
    margin-top: 0;
  `}
`

const MOITLogo = styled.div`
  background: #f8f9fa;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-radius: 8px;
  img {
    height: 40px;
    width: auto;
  }
`

export default ({ bg }) => (
  <StaticQuery
    query={graphql`
      {
        vi: markdownRemark(fields: { slug: { eq: "/vi/site-config/" } }) {
          frontmatter {
            footer {
              info {
                name
                address {
                  label
                  value
                }
                phone {
                  label
                  value
                }
              }
              menu {
                groupName
                menuList {
                  name
                  link
                }
              }
              mobileApp {
                label
                appStore {
                  link
                  icon {
                    publicURL
                  }
                }
                googlePlay {
                  link
                  icon {
                    publicURL
                  }
                }
              }
              sponsors
              acceptPayment {
                label
                visa {
                  publicURL
                }
                mastercard {
                  publicURL
                }
                momo {
                  publicURL
                }
                atm {
                  publicURL
                }
                mobileCard {
                  publicURL
                }
              }
              copyright {
                copyright
                businessLicense
              }
            }
          }
        }
        en: markdownRemark(fields: { slug: { eq: "/en/site-config/" } }) {
          frontmatter {
            footer {
              info {
                name
                address {
                  label
                  value
                }
                phone {
                  label
                  value
                }
              }
              menu {
                groupName
                menuList {
                  name
                  link
                }
              }
              mobileApp {
                label
                appStore {
                  link
                  icon {
                    publicURL
                  }
                }
                googlePlay {
                  link
                  icon {
                    publicURL
                  }
                }
              }
              sponsors
              acceptPayment {
                label
                visa {
                  publicURL
                }
                mastercard {
                  publicURL
                }
                momo {
                  publicURL
                }
                atm {
                  publicURL
                }
                mobileCard {
                  publicURL
                }
              }
              copyright {
                copyright
                businessLicense
              }
            }
          }
        }
      }
    `}
    render={data => {
      const currentLanguage = getCurrentLanguage()
      if (!_.has(data, currentLanguage)) return null
      const { menu, info, copyright, mobileApp, acceptPayment, sponsors } = data[currentLanguage].frontmatter.footer
      return (
        <Footer>
          <Container>
            <Row>
              <Col md={12} lg={4}>
                <CompanyInfo>
                  <div className='item name'>{info.name}</div>
                  <div className='item address'>
                    <i className='fas fa-map-marker-alt' />
                    <div style={{ flex: 1 }}>
                      <span className='label'>{info.address.label}</span>
                      <span className='value'>{renderText(info.address.value)}</span>
                    </div>
                  </div>
                  <div className='item phone'>
                    <i className='fas fa-phone-square' />
                    <div style={{ flex: 1 }}>
                      <span className='label'>{info.phone.label}</span>
                      <span className='value'>{info.phone.value}</span>
                    </div>
                  </div>
                </CompanyInfo>
              </Col>
              <Col md={12} lg={8}>
                <Row>
                  {menu.map((e, i) => (
                    <MenuListStyle key={i} xs={6} md={3}>
                      <label>{e.groupName}</label>
                      <div className='menuList'>
                        {e.menuList.map((menuItem, index) => (
                          <Menu
                            to={`${menuItem.link}`}
                            target='_blank'
                            key={index}
                          >
                            {menuItem.name}
                          </Menu>
                        ))}
                      </div>
                    </MenuListStyle>
                  ))}
                </Row>
                <MobileApp>
                  <label>{acceptPayment.label}</label>
                  <Stores>
                    <Store className='paymentMethod' src={acceptPayment.visa.publicURL} />
                    <Store className='paymentMethod' src={acceptPayment.mastercard.publicURL} />
                    <Store className='paymentMethod' src={acceptPayment.momo.publicURL} />
                    <Store className='paymentMethod' src={acceptPayment.atm.publicURL} />
                    <Store className='paymentMethod' src={acceptPayment.mobileCard.publicURL} />
                  </Stores>
                </MobileApp>
                <Row className='noMarginLeft noMarginRight'>
                  <MobileApp>
                    <label>{mobileApp.label}</label>
                    <DownloadMobileApp />
                  </MobileApp>
                  <MobileApp>
                    <label>{sponsors}</label>
                    <Store
                      src='https://tungtung-space.sgp1.cdn.digitaloceanspaces.com/static/community/logo/mongodb.png'
                      className='mongodb'
                    />
                  </MobileApp>
                </Row>
              </Col>
            </Row>
            <CopyrightWrapper>
              <Copyright>
                <div className='copyright'>{copyright.copyright}</div>
                <div className='businessLicense'>{copyright.businessLicense}</div>
              </Copyright>
              <MOITAndLanguages>
                <MOITLogo className='boCongThuongTradeMark' href='http://online.gov.vn/HomePage/WebsiteDisplay.aspx?DocId=54824' target='_blank'>
                  <img alt='MOITLogo' src='/img/bocongthuong.png' />
                </MOITLogo>
                <ChangeLanguage />
              </MOITAndLanguages>
            </CopyrightWrapper>
          </Container>
        </Footer>
      )
    }}
  />
)
